const mask = document.querySelector('.modal__mask');


/* ======================
   モーダル開く
====================== */
document.querySelectorAll('[data-id]').forEach(item => {

  item.addEventListener('click', () => {

    const modal = document.getElementById(item.dataset.id);

    if (modal) {
      modal.classList.add('is_active');
      mask.classList.add('is_active'); // 背景表示
    }

  });

});


/* ======================
   ×ボタンで閉じる
====================== */
document.querySelectorAll(
  '.news__modal--close, .products__modal--close'
).forEach(btn => {

  btn.addEventListener('click', closeModal);

});


/* ======================
   背景クリックで閉じる
====================== */
mask.addEventListener('click', closeModal);


/* ======================
   共通閉じ処理
====================== */
function closeModal(){

  document
    .querySelectorAll('.news__modal.is_active, .products__modal.is_active')
    .forEach(modal => {
      modal.classList.remove('is_active');
    });

  mask.classList.remove('is_active');

}